import React from 'react';
import { Hero } from './components/Hero';
import { OpeningLead } from './components/OpeningLead';
import { ChainReaction } from './components/ChainReaction';
import { TriggerMap } from './components/TriggerMap';
import { WhyItFails } from './components/WhyItFails';
import { WhatYouGet } from './components/WhatYouGet';
import { Testimonial } from './components/Testimonial';
import { Offer } from './components/Offer';
export function App() {
  return <div className="min-h-screen bg-[#f5f0e8] text-[#1e2a38]" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningLead data-id="element-2" />
      <ChainReaction data-id="element-3" />
      <TriggerMap data-id="element-4" />
      <WhyItFails data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <div className="bg-[#1e2a38] py-16 px-4 text-center" data-id="element-7">
        <div className="max-w-4xl mx-auto" data-id="element-8">
          <h2 className="text-2xl md:text-3xl font-serif text-white mb-4" data-id="element-9">
            Who this is for
          </h2>
          <p className="text-gray-300 text-lg" data-id="element-10">
            <span className="text-[#c9a07a] font-bold" data-id="element-11">For:</span> Women 55+
            dealing with menopause/perimenopause sleep-maintenance insomnia.
            <br className="hidden md:block" data-id="element-12" />
            <span className="text-gray-500 ml-2" data-id="element-13">
              Not for: Anyone needing urgent mental health support or medical
              diagnosis.
            </span>
          </p>
        </div>
      </div>
      <Testimonial data-id="element-14" />
      <Offer data-id="element-15" />

      <footer className="bg-[#1e2a38] text-gray-500 py-8 text-center text-sm border-t border-gray-800" data-id="element-16">
        <p data-id="element-17">
          © {new Date().getFullYear()} The 3AM Wake-Up Reset. All rights
          reserved.
        </p>
        <p className="mt-2" data-id="element-18">
          This is education + practical routines, not medical treatment.
        </p>
      </footer>
    </div>;
}